module.exports = __webpack_public_path__ + "media/site_templates/www.electriciannearme.agency/images/about_us-b998d11c5e5d78157528696fedd4a1b2.jpg";